// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"37508a86","86":"3e70b4bc"}[chunkId] + ".chunk.js";
};